var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--xs"
  }, [_c('v-col', {
    attrs: {
      "cols": ""
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "dense": "",
      "hide-details": "",
      "outlined": "",
      "append-icon": "mdi-magnify",
      "placeholder": "상품명을 검색하세요."
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.emit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query['searchValue'],
      callback: function ($$v) {
        _vm.$set(_vm.query, 'searchValue', $$v);
      },
      expression: "query['searchValue']"
    }
  }, 'v-text-field', {
    loading: _vm.loading
  }, false))], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', _vm._b({
    staticClass: "rounded-sm",
    attrs: {
      "color": "grey"
    },
    on: {
      "click": _vm.emit
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_vm._v("조회")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }